angular.module('app.filters').filter('detectedVideoInput', function($filter) {
    const STD_525_60 = 1;
    const STD_625_50 = 2;
    const STD_480i60 = 3;
    const STD_480p60 = 4;
    const STD_576p50 = 5;
    const STD_720p30 = 6;
    const STD_720p50 = 7;
    const STD_720p60 = 8;
    const STD_1080i50 = 10;
    const STD_1080i60 = 11;
    const STD_1080p30 = 12;
    const STD_1080p50 = 13;
    const STD_1080p60 = 14;
    const STD_480p30 = 15;
    const STD_576p25 = 16;
    const STD_720p25 = 17;
    const STD_1080p25 = 18;

    const compositeStandard = $filter('compositeStandard');
    const hdmiStandard = $filter('hdmiStandard');

    return function(adv7842) {
        if (adv7842 == null) {
            return '';
        } else if (adv7842.hdmi && adv7842.hdmi.cable_detected) {
            return hdmiStandard(adv7842.hdmi);
        } else if (adv7842.composite && adv7842.composite.video_detected) {
            return compositeStandard(adv7842.composite.standard);
        } else {
            return '';
        }
    };
});


// WEBPACK FOOTER //
// ./filters/detected_video_input.js